/* ORIAVI performance loader — quantity popover code only when the component is present or requested. */
(() => {
  const currentScript = document.currentScript;
  const currentSrc = currentScript && currentScript.src;
  if (!currentSrc) return;

  const coreUrl = new URL(currentSrc, window.location.href);
  coreUrl.pathname = coreUrl.pathname.replace(/quantity-popover\.js$/, 'quantity-popover-core.js');
  coreUrl.search = '';
  const coreSrc = coreUrl.toString();
  let loadPromise;

  const loadCore = () => {
    if (loadPromise) return loadPromise;
    loadPromise = new Promise((resolve, reject) => {
      const existing = document.querySelector('script[data-oriavi-quantity-popover-core]');
      if (existing) {
        if (existing.dataset.loaded === 'true') resolve();
        else {
          existing.addEventListener('load', resolve, { once: true });
          existing.addEventListener('error', reject, { once: true });
        }
        return;
      }

      const script = document.createElement('script');
      script.src = coreSrc;
      script.async = true;
      script.dataset.oriaviQuantityPopoverCore = 'true';
      script.addEventListener('load', () => {
        script.dataset.loaded = 'true';
        resolve();
      }, { once: true });
      script.addEventListener('error', reject, { once: true });
      document.head.appendChild(script);
    });
    return loadPromise;
  };

  const loadIfNeeded = () => {
    if (document.querySelector('quantity-popover')) loadCore();
  };

  const onIntent = (event) => {
    if (!(event.target instanceof Element)) return;
    if (event.target.closest('quantity-popover')) loadCore();
  };

  window.oriaviLoadQuantityPopover = loadCore;
  loadIfNeeded();
  document.addEventListener('cartdrawer:opened', loadIfNeeded);
  document.addEventListener('cart:updated', loadIfNeeded);
  document.addEventListener('shopify:section:load', loadIfNeeded);
  document.addEventListener('pointerover', onIntent, { capture: true, passive: true });
  document.addEventListener('focusin', onIntent, true);
})();
